import React from 'react'
import ReactDOM from 'react-dom'
import Preview from './Preview'

// 动态添加文件预览dom节点
const createPreview = () => {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const previewDom = ReactDOM.hydrate(<Preview />, div)
  return {
    addFile(files, index, isWater, updateImg, closeCallBack) {
      return previewDom.addFile(files, index, isWater, updateImg, closeCallBack)
    },
    destroy() {
      ReactDOM.unmountComponentAtNode(div)
      document.body.removeChild(div)
    },
  }
}

let preview
const previewFile = (files, index, isWater, updateImg, closeCallBack) => {
  if (!preview) preview = createPreview()
  return preview.addFile(files, index, isWater, updateImg, closeCallBack)
}

const removeFile = () => {
  if (preview) {
    preview.destroy()
  }
}

export default {
  preview(files, index, isWater, updateImg, closeCallBack) {
    return previewFile(files, index, isWater, updateImg, closeCallBack)
  },
  // 外部调用
  close() {
    return removeFile()
  },
}
